import { useState } from 'react';
import styled, { css } from 'styled-components';
import IconButton from './IconButton';
import Icon from './Icon';
import Dropdown from './Dropdown';
import useOutsideClick from 'utils/useOutsideClick';
import EditBox from './EditBox';

const ToolbarSuggestionFeedbacks = () => {
  /* State */
  const [posFeedbackDropdown, setPosFeedbackDropdown] = useState(false);
  const [negFeedbackDropdown, setNegFeedbackDropdown] = useState(false);
  const [posFeedbackLeft, setPosFeedbackLeft] = useState(false);
  const [negFeedbackLeft, setNegFeedbackLeft] = useState(false);

  /* Refs */
  const refPosDropdown = useOutsideClick(() => setPosFeedbackDropdown(false));
  const refNegDropdown = useOutsideClick(() => setNegFeedbackDropdown(false));

  /* Functions */

  const handlePositiveFeedback = () => {
    setPosFeedbackDropdown(false);
    setPosFeedbackLeft(true);
    setNegFeedbackLeft(false);
  };

  const handleNegativeFeedback = () => {
    setNegFeedbackDropdown(false);
    setNegFeedbackLeft(true);
    setPosFeedbackLeft(false);
  };

  return (
    <Wrapper>
      <FeedbackItem>
        <FeedbackButton
          positive
          active={posFeedbackLeft}
          icon='thumbs-up'
          iconSource='feather'
          onClick={() => setPosFeedbackDropdown(true)}
        />
        {posFeedbackDropdown && (
          <Dropdown ref={refPosDropdown} align='right'>
            <FeedbackDropdownContent positive>
              <Line>
                <Icon source='feather' name='thumbs-up' />
                <span>Provide additional feedback</span>
              </Line>
              <Line>
                <EditBox
                  submitOnEnter
                  withButton='lizzy-send'
                  placeholder='What did you liked about the answer?'
                  onSubmit={handlePositiveFeedback}
                />
              </Line>
            </FeedbackDropdownContent>
          </Dropdown>
        )}
      </FeedbackItem>

      <FeedbackItem>
        <FeedbackButton
          negative
          active={negFeedbackLeft}
          icon='thumbs-down'
          iconSource='feather'
          onClick={() => setNegFeedbackDropdown(true)}
        />
        {negFeedbackDropdown && (
          <Dropdown ref={refNegDropdown} align='right'>
            <FeedbackDropdownContent negative>
                <Line>
                  <Icon source='feather' name='thumbs-down' />
                  <span>Provide additional feedback</span>
                </Line>
                <Line>
                  <EditBox
                    submitOnEnter
                    withButton='lizzy-send'
                    placeholder='How can Lizzy improve an answer?'
                    onSubmit={handleNegativeFeedback}
                  />
                </Line>
              </FeedbackDropdownContent>
          </Dropdown>
        )}
      </FeedbackItem>
    </Wrapper>
  );
}

export default ToolbarSuggestionFeedbacks;

const Wrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
`;

const FeedbackItem = styled.div`
  position: relative;
`;

const FeedbackDropdownContent = styled.div`
  font-size: 14px;
  width: 300px;

  ${p => p.positive && css`
    ${Icon} {
      margin-right: 9px;
      color: var(--lizzy-success);
    }
  `}

  ${p => p.negative && css`
    ${Icon} {
      margin-right: 9px;
      color: var(--lizzy-error);
    }
  `}
`;

const Line = styled.div`
  white-space: nowrap;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  
  &:not(:last-child) {
    margin-bottom: 10px;
  }
`;

const FeedbackButton = styled(IconButton)`
  ${p => p.positive && p.active && css`
    ${Icon} {
      color: var(--lizzy-success);
    }
  `}

  ${p => p.negative && p.active && css`
    ${Icon} {
      color: var(--lizzy-error);
    }
  `}
`;